import React from 'react';
import Collection from './Collection';

const query = {
  sort: 'title asc',
  include: {
    blog_count: {
      url: '/content/blogs/:count',
      params: {
        category_id: 'id',
      },
    },
  },
};

export const tabs = {
  default: {
    label: 'All categories',
  },
};

const filters = {
  date_created: {
    label: 'Created',
    operators: ['after', 'before'],
    type: 'date',
  },
};

const fields = {
  title: {
    label: 'Category title',
    default: true,
  },
  slug: {
    label: 'Slug',
  },
  blog_count: {
    label: 'Blogs',
    sort: false,
    func({ blog_count }) {
      return <>{blog_count}</>;
    },
  },
  updated: {
    label: 'Updated',
    type: 'date',
    func({ date_created, date_updated }) {
      return date_updated || date_created;
    },
  },
};

const headerActions = [
  {
    label: 'Manage blogs',
    fa: 'pen-to-square',
    type: 'sub',
    link: '/content/blogs',
    showAlways: true,
  },
  { label: 'New category', link: '/content/blog-categories/new' },
];

export default class ContentBlogCategories extends React.Component {
  render() {
    return (
      <Collection
        {...this.props}
        title="Blog categories"
        uri="/content/blog-categories"
        model="content/blog-categories"
        emptyDescription="Manage blog categories published in your storefront."
        tabs={tabs}
        filters={filters}
        fields={fields}
        headerActions={headerActions}
        query={query}
      />
    );
  }
}
